import cx from 'classnames';
import type { FC } from 'react';

import LucaWithSparkes from './assets/luca-with-sparkles.svg?react';
import LucaWithoutSparkles from './assets/luca-without-sparkles.svg?react';

interface Props {
  className?: string;
  size?: 'smallest' | 'small' | 'medium' | 'large' | 'largest';
  withSparkles?: boolean;
}

const LucaAvatar: FC<Props> = ({ className, size = 'smallest', withSparkles = true }) => {
  const AvatarComponent = withSparkles ? LucaWithSparkes : LucaWithoutSparkles;

  const classNames: string = cx(
    {
      'w-3 h-3': size === 'smallest',
      'w-4 h-4': size === 'small',
      'w-6 h-6': size === 'medium',
      'w-8 h-8': size === 'large',
      'w-16 h-16': size === 'largest'
    },
    className
  );

  return <AvatarComponent className={classNames} data-testid="luca-avatar" />;
};

export default LucaAvatar;
